<template>
  <div  style="width: 100%; font-size: 11px;" class="small-text" >
    <v-card>
      <table >
        <thead style="font-weight: 500">
          <td style="width: 30%; padding-right: 6px; border-right: solid 1px black;">Zone<br>Drivers</td>
          <td style="width: 15%; padding-right: 6px; border-right: solid 1px black;">Free</td>
          <td style="width: 15%; padding-right: 6px; border-right: solid 1px black;">ATC</td>
          <td style="width: 15%; padding-right: 6px; border-right: solid 1px black;">POB</td>
          <td>OW</td>
        </thead>
        <tr>
          <td style="padding-right: 6px; border-right: solid 1px black;">{{bookingForm.booking.zone != null ? bookingForm.booking.zone.name : ''}}</td>
          <td style="padding-right: 6px; border-right: solid 1px black;">{{availableTaxis()}}</td>
          <td style="padding-right: 6px; border-right: solid 1px black;">{{aboutToClearTaxis()}}</td>
          <td style="padding-right: 6px; border-right: solid 1px black;">{{pobTaxis()}}</td>
          <td>{{owTaxis()}}</td>
        </tr>
      </table>
    </v-card>
  </div>
</template>

<script>
import { Overwatch } from "@/components/util/Overwatch.js";

export default {
  name: "taxi_zone_summary",
  components: {
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    taxis: Array,
    bookings: Array,
    zones: Array,
    bookingForm: Object
  },
  computed: {
    
  },
  data() {
    return {
    };
  },
  methods: {
    taxisForZone: function(id) {
      if (this.taxis == null) {
        return [];
      }

      var ow = new Overwatch(
        this.taxis,
        this.bookings,
        this.$store.state.use_zone_based_dispatch
      );

      return ow.sortTaxisByState(
        this.taxis.filter(function(t) {
          return t.zone == id;
        })
      );
    },
    availableTaxis: function() {

      if (this.bookingForm.booking.zone == null) {
        return [];
      }

      var taxis = this.taxisForZone(this.bookingForm.booking.zone.id);

      return taxis.filter(function(t) {
          return t.state == 'available' || t.state == 'job_sent';
        }).length;
    },
    aboutToClearTaxis: function(id) {

      if (this.bookingForm.booking.zone == null) {
        return [];
      }

      var taxis = this.taxisForZone(this.bookingForm.booking.zone.id);

      var ow = new Overwatch(
        this.taxis,
        this.bookings,
        this.$store.state.use_zone_based_dispatch
      );

       return taxis.filter(function(t) {
          return ow.categoryForTaxi(t) == "about_to_clear";
        }).length;
    },
    pobTaxis: function(id) {

      if (this.bookingForm.booking.zone == null) {
        return [];
      }

       var taxis = this.taxisForZone(this.bookingForm.booking.zone.id);

      var ow = new Overwatch(
        this.taxis,
        this.bookings,
        this.$store.state.use_zone_based_dispatch
      );

      return taxis.filter(function(t) {
          return ow.categoryForTaxi(t) == "pob";
        }).length;
    },
    owTaxis: function(id) {

      if (this.bookingForm.booking.zone == null) {
        return [];
      }

      var taxis = this.taxisForZone(this.bookingForm.booking.zone.id);

      var ow = new Overwatch(
        this.taxis,
        this.bookings,
        this.$store.state.use_zone_based_dispatch
      );

      return taxis.filter(function(t) {
        return t.state == 'on_job'
      }).length;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

table { border-collapse: collapse; }
tr { border: none; }

ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  // color: green;
  font-weight: 800;
}

.small-text {
  font-size: 13px;
}
</style>
